// React binding of the JobManager (jobManager.ts): all summary jobs, keyed by video ID.

import { useEffect, useState, useSyncExternalStore } from 'react';
import { JobManager, type JobCallbacks } from './jobManager';

export {
  MAX_CONCURRENT,
  SERVER_BLOCKED_NOTICE,
  stageIndex,
  type Job,
  type JobCallbacks,
  type JobContext,
  type JobError,
  type JobSource,
  type Jobs,
  type JobStatus,
  type StartOptions,
} from './jobManager';


/**
 * Call it before effects that start jobs (App's route effect): effects run in order, and jobs that
 * were running on the server before a reload must be re-attached first (login lock order).
 */
export function useSummaryJobs(callbacks: JobCallbacks) {
  const [manager] = useState(() => new JobManager(callbacks));
  useEffect(() => {
    manager.setCallbacks(callbacks);
  });
  // Idempotent (StrictMode runs it twice): videos that already have a job are skipped.
  useEffect(() => manager.resumePersisted(), [manager]);
  const jobs = useSyncExternalStore(manager.subscribe, manager.getSnapshot);
  return { jobs, manager };
}
